import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, BasicTooltip, Icon, toast } from '@livable/saas-react-components';
import { Alert, Paper, Typography, IconButton } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAllocationUtilityStyles from 'src/pages/AllocationTablesPage/AllocationUtility/styles';
import { useStore } from 'src/stores';
import FinancialTextInput from 'src/components/shared/FinancialTextInput';
import { useDelay } from 'src/utils/hooks';
import useFSEBillContentStyles from './styles';
import InputCell from './inputCell';
const FSEBillContent = observer(_ref => {
  let residencyId = _ref.residencyId,
    unitName = _ref.unitName,
    propertyId = _ref.propertyId;
  const store = useStore();
  const classes = useAllocationUtilityStyles();
  const fseBillClasses = useFSEBillContentStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const accountId = store.fse.accountId;
  const profileName = store.account.profilesFullName.get(accountId);
  const totals = store.fse.totals;
  const _useState = useState(totals.goodWillDeductionPercent),
    _useState2 = _slicedToArray(_useState, 2),
    amount = _useState2[0],
    setAmount = _useState2[1];
  const getFinalStatements = async () => {
    const resp = await store.fse.getFinalStatementsAsync.run({
      residencyId
    });
    return resp;
  };
  const getFSEInfos = async () => {
    const resp = await store.fse.getFSEInfosAsync.run({
      residencyIds: [residencyId]
    });
    return resp;
  };
  const updateFinalStatements = async data => {
    const resp = await store.fse.updateFinalStatementsAsync.run(data);
    return resp;
  };
  const getUtilityInfo = async ids => {
    if (!store.account.featureFlagsStore.getIsBillAutomationEnabled || !store.account.featureFlagsStore.getIsBillingTemplatesEnabled) {
      const resp = await store.utilityProviders.getUtilityInfoAsync.run({
        utilityIds: ids
      });
      return resp;
    } else {
      const resp = await store.utilityProviders.getPropertyUtilityInfoAsync.run({
        utilityIds: ids,
        propertyId
      });
      return resp;
    }
  };
  const getStatemens = () => getFinalStatements().then(() => getUtilityInfo(store.fse.finalStatements.map(item => item.utilityId)));
  const update = () => {
    const data = {
      finalStatementId: store.fse.finalStatementId,
      goodWillDeductionPercent: totals.goodWillDeductionPercent,
      items: [...store.fse.finalStatements].map(item => ({
        chargeAmount: item.chargeAmount,
        id: item.id,
        isExcluded: item.isExcluded,
        memo: item.chargeMemo,
        chargeMemo: item.chargeMemo
      }))
    };
    updateFinalStatements(_objectSpread(_objectSpread({}, data), {}, {
      goodWillDeductionPercent: amount
    })).then(() => {
      toast('success', {
        body: [t('fse_page.updated')]
      });
    }).then(() => getStatemens()).then(() => getFSEInfos());
  };
  useEffect(() => {
    if (totals.goodWillDeductionPercent !== amount) setAmount(totals.goodWillDeductionPercent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totals.goodWillDeductionPercent]);
  useDelay(() => {
    if (amount >= 0 && totals.goodWillDeductionPercent !== amount) {
      store.fse.updateActualGoodwillDeduction(amount);
      update();
    }
  }, [amount], 1000);
  const summaries = [t('general.unit'), t('general.address'), t('file_cabinet.resident')];
  const summaryObj = {
    Address: store.addNewProperty.propertyInformationSnapshot.propertyAddress,
    Resident: profileName,
    Unit: unitName
  };
  const boldStyle = {
    fontSize: '18px',
    fontWeight: 600
  };
  const renderHeaderCell = _ref2 => {
    let dollarSign = _ref2.dollarSign,
      parameter = _ref2.parameter,
      width = _ref2.width;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        padding: '6px 10px',
        borderRadius: '2px',
        width: "".concat(width || 94, "px")
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.cellLeft || fseBillClasses.cellLeft)
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.overflowCell,
      variant: "body1"
    }, dollarSign ? '$' : '', parameter)));
  };
  const renderCell = _ref3 => {
    let bold = _ref3.bold,
      dollarSign = _ref3.dollarSign,
      parameter = _ref3.parameter,
      justify = _ref3.justify,
      leftIcon = _ref3.leftIcon,
      info = _ref3.info,
      width = _ref3.width,
      _ref3$infoText = _ref3.infoText,
      infoText = _ref3$infoText === void 0 ? '' : _ref3$infoText,
      _ref3$shouldOverflow = _ref3.shouldOverflow,
      shouldOverflow = _ref3$shouldOverflow === void 0 ? true : _ref3$shouldOverflow;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.overflowCellWrapper,
      style: {
        padding: '6px 10px',
        borderRadius: '2px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(justify === 'left' ? classes.cellLeft : fseBillClasses.cellRight),
      style: {
        alignItems: 'center',
        display: 'flex',
        maxWidth: width && Number(width) > 94 ? 'none' : '94px',
        width: "".concat(width || 94, "px")
      }
    }, leftIcon && /*#__PURE__*/React.createElement("div", {
      style: {
        marginRight: '4px'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      fontSize: 'small',
      type: parameter === null || parameter === void 0 ? void 0 : parameter.toLowerCase()
    })), /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      className: shouldOverflow ? classes.overflowCell : '',
      style: _objectSpread(_objectSpread({}, bold ? boldStyle : {}), !shouldOverflow ? {
        textAlign: 'initial'
      } : {})
    }, dollarSign ? '$' : '', parameter), info && /*#__PURE__*/React.createElement("div", {
      style: {
        marginLeft: '2px'
      }
    }, /*#__PURE__*/React.createElement(BasicTooltip, {
      title: infoText,
      placement: "top",
      hideOnMobile: true
    }, /*#__PURE__*/React.createElement(IconButton, {
      size: "small"
    }, /*#__PURE__*/React.createElement(Icon, {
      fontSize: "small",
      type: "info"
    }))))));
  };
  const renderTwoLinesCell = (parameter, parameter2) => /*#__PURE__*/React.createElement("div", {
    className: classes.overflowCellWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " ").concat(classes.cellLeft)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.overflowCell
  }, parameter, " day", parameter > 1 ? 's' : ''), /*#__PURE__*/React.createElement(Typography, {
    color: "light",
    className: classes.overflowCell,
    variant: "body1"
  }, parameter2))));
  return /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.fse.FSEBillModalIsLoading
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '0 16px',
      background: '#f8f9fa'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      background: 'rgb(255 255 255)'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: fseBillClasses.summaryWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: fseBillClasses.summaryBlocks
  }, summaries.map(summary => /*#__PURE__*/React.createElement("div", {
    key: summary,
    className: fseBillClasses.summaryBlock
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, summary), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, summaryObj[summary]))))), /*#__PURE__*/React.createElement("div", {
    className: fseBillClasses.statementRow
  }, renderHeaderCell({
    justify: 'left',
    parameter: 'Utility',
    width: 150
  }), renderHeaderCell({
    justify: 'left',
    parameter: 'Unbilled days',
    width: 200
  }), renderHeaderCell({
    justify: 'left',
    parameter: 'Recommended charge',
    width: 180
  }), renderHeaderCell({
    justify: 'left',
    parameter: 'Adjusted charge',
    width: 230
  }), renderHeaderCell({
    justify: 'left',
    parameter: 'Utility',
    width: 180
  })), store.fse.finalStatements.map(statement => {
    var _store$utilityProvide;
    return /*#__PURE__*/React.createElement("div", {
      className: fseBillClasses.statementRow,
      key: statement.utilityId
    }, renderCell({
      leftIcon: true,
      justify: 'left',
      width: 200,
      parameter: (_store$utilityProvide = store.utilityProviders.utilities.get(statement.utilityId)) === null || _store$utilityProvide === void 0 ? void 0 : _store$utilityProvide.utilityTypeName,
      shouldOverflow: false
    }), renderTwoLinesCell(statement.daysCount, "".concat(statement.periodStartDateOnly || '', " - ").concat(statement.periodEndDateOnly || '')), renderCell({
      dollarSign: true,
      parameter: statement.recommendedCharge.toFixed(2),
      info: true,
      infoText: t('fse_page.hint_recommended_charge')
    }), /*#__PURE__*/React.createElement(InputCell, {
      amountData: statement.chargeAmount,
      id: statement.id,
      parameter: "updateChargeAmount",
      updateAmount: store.fse.updateChargeAmount,
      updateFSE: update
    }), renderCell({
      dollarSign: true,
      parameter: statement.total.toFixed(2)
    }));
  }), /*#__PURE__*/React.createElement("div", {
    className: fseBillClasses.totalBlock
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: '150px'
    }
  }, store.fse.getFinalStatementsAsync.inProgress ? /*#__PURE__*/React.createElement(FinancialTextInput, {
    handleInputChange: () => {},
    inputLabel: t('fse_page.goodwill_discount'),
    percentageSign: true,
    withAdorment: true,
    percentSignOnRight: true
  }) : /*#__PURE__*/React.createElement(FinancialTextInput, {
    handleInputChange: setAmount,
    inputLabel: t('fse_page.goodwill_discount'),
    percentageSign: true,
    refresh: true,
    withAdorment: true,
    valueExt: amount,
    percentSignOnRight: true
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('fse_page.estimated_total'), " $", totals.actualTotal.toFixed(2)), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('fse_page.current_balance'), ": $", totals.currentBalance.toFixed(2))), store.account.featureFlagsStore.isFinalStatementEstimationEnabled && false ? /*#__PURE__*/React.createElement("div", {
    className: classes.smSection,
    style: {
      borderTop: '1px solid #f0f0f0'
    }
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('fse_page.notice')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('fse_page.notice_text')))) : null);
});
export default FSEBillContent;